import { render, staticRenderFns } from "./BaseIcon.component.html?vue&type=template&id=7ed74a44&scoped=true&external"
import script from "./BaseIcon.component.ts?vue&type=script&lang=ts&external"
export * from "./BaseIcon.component.ts?vue&type=script&lang=ts&external"
import style0 from "./BaseIcon.component.scss?vue&type=style&index=0&id=7ed74a44&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed74a44",
  null
  
)

export default component.exports